import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class KorrekturWaermeerzeugerHeizung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    kombination: number | null = null;
    waermeerzeuger_heizung_1_id: number | null = null;
    korrektur_waermeerzeuger_heizung_1_id: number | null = null;
    energie_waermequelle_1_id: number | null = null;
    korrektur_energie_waermequelle_1_id: number | null = null;
    waermeerzeuger_heizung_2_id: number | null = null;
    korrektur_waermeerzeuger_heizung_2_id: number | null = null;
    energie_waermequelle_2_id: number | null = null;
    korrektur_energie_waermequelle_2_id: number | null = null;
    bemerkung: string | null = null;

    // view fields
    energie_waermequelle_1_i18n_key: string | null = null;
    korrektur_energie_waermequelle_1_i18n_key: string | null = null;
    energie_waermequelle_2_i18n_key: string | null = null;
    korrektur_energie_waermequelle_2_i18n_key: string | null = null;
    waermeerzeuger_heizung_1: string | null = null;
    korrektur_waermeerzeuger_heizung_1: string | null = null;
    waermeerzeuger_heizung_2: string | null = null;
    korrektur_waermeerzeuger_heizung_2: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'KorrekturWaermeerzeugerHeizung';
    }
}

export async function createNewKorrekturWaermeerzeugerHeizung(): Promise<KorrekturWaermeerzeugerHeizung> {
    const korrekturwaermeerzeugerheizung = createModel(KorrekturWaermeerzeugerHeizung, {});

    await korrekturwaermeerzeugerheizung.save();
    return korrekturwaermeerzeugerheizung;
}

export class KorrekturWaermeerzeugerHeizungCollection extends BaseCollection<KorrekturWaermeerzeugerHeizung> {
    protected modelCls = KorrekturWaermeerzeugerHeizung;

    public getModelClassName(): string {
        return 'KorrekturWaermeerzeugerHeizung';
    }
}
